/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
// import autosize from 'autosize';

$(document).ready(function () {
    /**
     * Plugins
     * */
    require('./plugins/formSessions')
    require('./plugins/sidepanelInputFocus')
    require('./plugins/sortableTable')
    require('./plugins/fileUploadNameShow');
    require('./plugins/jQuery/jQuery.formDataExtension')
    require('./plugins/jQuery/jQuery.swapSiblings')

    /**
     * Components
     * */
    require('./components/activities');
    require('./components/menu');
    require('./components/sidebar');
    require('./components/confirm');
    require('./components/activities');
    require('./components/placeholders/replacer');
    require('./components/map');
    require('./components/insert-at-caret')

    /**
     * Modules
     **/
    require('./modules/users')
    require('./modules/country-state-select')
    require('./modules/tasks');
});
